module.exports = __webpack_public_path__ + "static/img/3.1264601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/3.png
// module id = QyUH
// module chunks = 0